module.exports = require("./lib/stream-length");
